// Google Ads conversion tracking helper
export const GADS_SEND_TO = "AW-18350163210/j80LCILavdYcEIqKha5E";

export function trackConversion() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: GADS_SEND_TO });
  }
}
